export enum RateUsage {
  RATE_SHOP = 'RATE_SHOP',
  BENCHMARK = 'BENCHMARK',
  COST_MANAGEMENT_BENCHMARK = 'COST_MANAGEMENT_BENCHMARK',
}
